/* eslint-disable no-useless-escape */
import dayjs, { Dayjs } from 'dayjs';

export const SERVER_DATE_FORMAT = 'YYYY-MM-DD';
export const SERVER_TIME_FORMAT = 'HH:mm:ss';
export const SERVER_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const toAPITDate = (date: Dayjs) => date.format(SERVER_DATE_FORMAT);

export const toAPITDateTime = (date: Dayjs) => date.format(SERVER_DATETIME_FORMAT);

const _processStrings = (value: string): any => {
  // https://stackoverflow.com/questions/14488745/javascript-json-date-deserialization
  const reISO = /^\d{4}-(0[1-9]|1[0-2])-([12]\d|0[1-9]|3[01])([T\s](([01]\d|2[0-3])\:[0-5]\d|24\:00)(\:[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3])\:?([0-5]\d)?)?)?$/;
  const reMsAjax = /^\/Date\((d|-|.*)\)[\/|\\]$/;
  if (reISO.exec(value)) {
    // if so, Date() can parse it:
    return dayjs(new Date(value));
  }
  // otherwise, see if it's a wacky Microsoft-format string:
  const a = reMsAjax.exec(value);
  if (a) {
    // and perform some jujitsu to make use of it:
    const b = a[1].split(/[-+,.]/);
    return dayjs(new Date(b[0] ? +b[0] : 0 - +b[1]));
  }

  return value;
};

const _parseArray = <T extends object>(arr: T[]) => {
  for (let i = 0; i < arr.length; i += 1) {
    const value = arr[i];
    if (value instanceof Date) {
      // eslint-disable-next-line no-param-reassign
      arr[i] = dayjs(arr[i] as unknown as Date) as any;
    } else if (Array.isArray(value)) {
      _parseArray(value);
    } else if (value instanceof Object) {
      _parseObject(value);
    } else if (typeof value === 'string') {
      // eslint-disable-next-line no-param-reassign
      arr[i] = _processStrings(value);
    } else {
      return value;
    }
  }

  return arr;
};

export const _parseObject = <T extends ArrayLike<unknown> | object>(obj: T): void => {
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(obj)) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (value instanceof Date) {
        const o = obj as any;
        o[key] = dayjs(o[key] as Date);
      } else if (Array.isArray(value)) {
        _parseArray(value);
      } else if (value instanceof Object) {
        _parseObject(value);
      } else if (typeof value === 'string') {
        const o = obj as any;
        // eslint-disable-next-line no-param-reassign
        o[key] = _processStrings(value);
      }
    } else if (typeof value === 'string') {
      const o = obj as any;
      // eslint-disable-next-line no-param-reassign
      o[key] = _processStrings(value);
    }
  }
};

/** *
 * Recursively replace all instances of Date with a dayjs instance
 */
export const recursivelyChangeDateFormat = <T extends ArrayLike<unknown> | object | undefined | null>(obj: T) => {
  if (!obj) { return; }
  _parseObject(obj);
};
